




































import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { Page } from '@getaccept/dsr-shared/src/types/page';
import { SidebarPlacement } from '@getaccept/dsr-shared/src/types/sidebar-placement';
import SidebarInnerWrapper from '@getaccept/dsr-shared/src/components/SidebarInnerWrapper.vue';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import type { DocumentRecipientRevision } from '@getaccept/lib-shared/src/types/document-revision';
import PoweredByLogo from './../../assets/powered-by-ga.svg';
import BlockListItem from './BlockListItem.vue';

export default defineComponent({
  name: 'PageNavigationBar',
  components: {
    SidebarInnerWrapper,
    BlockListItem,
    PoweredByLogo,
  },
  props: {
    pages: {
      default: () => [],
      type: Array as PropType<Page[]>,
    },
    currentPageId: {
      type: String,
      default: null,
    },
    recipient: {
      type: Object as PropType<Recipient>,
      default: null,
    },
    latestViewedRevision: {
      type: Object as PropType<DocumentRecipientRevision>,
      default: null,
    },
  },
  setup(props) {
    const handlePoweredByClick = () => window.open('https://www.getaccept.com', '_blank');

    const visiblePages = computed(() =>
      props.pages.filter(
        ({ editorBlock }) => !editorBlock.content.sections.every(({ hidden }) => hidden)
      )
    );

    return {
      SidebarPlacement,
      handlePoweredByClick,
      PoweredByLogo,
      visiblePages,
    };
  },
});
